module.exports = __webpack_public_path__ + "static/media/mini-trash-icon.fd64fad3.svg";